export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9926.4dadabb3.jpg";